// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SY6g","rootNoMargin":"styles_rootNoMargin__FUQcI"};